import React from 'react'
import Styles from './thumbnails.module.css'

const SportThumb = () => {
  return (
       <h2 className={Styles.sportHeader}>Tottenham Hotspurs</h2>
  )
}

export default SportThumb